import React from "react";
import { TailSpin } from "react-loader-spinner";
import exportLottie from "../../lotties/export.json";
import Lottie from "react-lottie";

const defaultExportOptions = {
  loop: true,
  autoplay: true,
  animationData: exportLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function LoadingOverlay({ showSpinner, active, text, opacity, spinnerType }) {
  return (
    active && (
      <div className="overlay-height" style={{ opacity: opacity }}>
        <div>
          {showSpinner &&
            (spinnerType === "defaultExportOptions" ? (
              <Lottie options={defaultExportOptions} height={400} width={400} />
            ) : (
              <>
                <TailSpin
                  color="white"
                  height={45}
                  strokeWidth={2}
                  width={"100%"}
                />
                <p className="overlay-text">{text}</p>
              </>
            ))}
        </div>
      </div>
    )
  );
}

export default LoadingOverlay;
